import { getDefaultOnlineMeetingsEnabled } from 'owa-calendar-cloud-settings';
import { getComposeViewState } from 'owa-calendar-compose-store-manager';
import { isCalendarEventLocalLie } from 'owa-calendar-event-local-lie';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

/**
 * Checks if the event qualifies to be online by default if:
 * - the default online setting is on
 * - the online meeting wasn't explicitly set by the user
 * - it's event creation, i.e. not event update (the online meeting was set by the user when the event was created)
 * @param event
 */
export default function shouldEnableDefaultOnlineMeeting(
    event: CalendarEvent,
    formId: string
): boolean {
    return (
        getDefaultOnlineMeetingsEnabled() &&
        !getComposeViewState(formId).isOnlineMeetingExplicitlySet &&
        isCalendarEventLocalLie(event)
    );
}
